// eslint-disable-next-line @typescript-eslint/no-explicit-any
const metaEnv = import.meta.env as Record<string, any>;

const required = (key: string): string => {
  const value = metaEnv[key] as string | undefined;
  if (!value) {
    throw new Error(`[env] Missing required environment variable: ${key}`);
  }
  return value;
};

const optional = (key: string, fallback: string): string =>
  (metaEnv[key] as string | undefined) ?? fallback;

export const env = {
  API_BASE_URL: required('VITE_API_BASE_URL'),
  APP_NAME: optional('VITE_APP_NAME', 'LIFTIQ Admin'),
  APP_VERSION: optional('VITE_APP_VERSION', '0.0.0'),
  ENABLE_DEVTOOLS: optional('VITE_ENABLE_DEVTOOLS', 'false') === 'true',
} as const;

export type AppEnv = typeof env;
